var VERSION = 1779948370352
export  {
	VERSION
} 
